import { useState, useEffect } from "react";
import {
  motion,
  useMotionValue,
  useTransform,
  useAnimation,
} from "framer-motion";
import { FaGithub, FaExternalLinkAlt, FaInfoCircle } from "react-icons/fa";

// Images
import Img1 from "../assets/portfolio-img1.png";
import Img3 from "../assets/portfolio-img3.png";
import Pix from "../assets/freepik__web-developer-workspace-under-construction-laptop-__19395.png";
import Wat from "../assets/watowatch.png";
import Air from "../assets/airbnb mobile.png";
import Jeego from "../assets/Jeego-jeux.png";
import DomisimpliWeb from "../assets/Domisimpli-web.png";
import DomisimpliApp from "../assets/Domisimpli-app.jpeg";
import Coodent from "../assets/siteCoodent.png";

// Projets avec type "pro" ou "perso"
const projects = [
  {
    title: "Domisimpli Web",
    type: "pro",
    date: "2025",
    description: "Le site web DomiSimpli est la vitrine digitale de l’application mobile DomiSimpli sur la gestion administrative des services d’emploi à domicile. Elle informe les utilisateurs sur les démarches légales, les contrats, le CESU, les déclarations et les tarifs forfaitaires.",
    image: DomisimpliWeb,
    demo: "https://www.youtube.com/watch?v=3m0kPL-pyrk",
    more: "https://www.notion.so/DomiSimpli-Le-Site-Web-Fullstack-TypeScript-Next-js-Django-PostgreSQL-2df7a480c77c80d39385ef2d86ede072?showMoveTo=true&saveParent=true",
  },
  {
    title: "Domisimpli App",
    type: "pro",
    date: "2025",
    description: "DomiSimpli est une application mobile pour simplifier la gestion des emplois à domicile, destinée aux particuliers employeurs et aux salariés à domicile. Elle facilite la mise en relation entre employeurs et employés à proximité, tout en offrant des outils pour gérer plannings, suivi des heures, contrats, et démarches administratives légales.",
    image: DomisimpliApp,
    demo: "https://play.google.com/store/apps/details?id=fr.coodent.domisimpli&hl=fr",
    more: "https://www.notion.so/DomiSimpli-Application-Mobile-React-Native-Expo-Django-PostgreSQL-2e07a480c77c80faabcdf51969ff6923",
  },
  {
    title: "Site Coodent",
    type: "pro",
    date: "2024",
    description: "Développement complet du site web et de la plateforme de Coode-nt, startup spécialisée dans les solutions digitales. J’ai travaillé sur l’ensemble de la stack : frontend React/Redux, backend Django/PostgreSQL, intégration des contenus et déploiement. Le site sert de vitrine professionnelle et permet de gérer les projets et services de la startup..",
    image: Coodent,
    more: "https://www.notion.so/Coode-nt-Site-Web-Corporate-React-Django-PostgreSQL-2f87a480c77c8015a2daf36f6207d090?pvs=48",
  },
  {
    title: "Jeego – Plateforme de Jeux Interactifs Phygitaux",
    type: "pro",
    date: "2023",
    description: "Plateforme de jeux interactifs « Scan & Play » pour animer des espaces physiques (centres commerciaux, événements…). Participation au développement front-end et au maquettage des jeux ainsi qu'au site web. Technologies utilisées : PWA React TypeScript Node.js.",
    image: Jeego,
    demo: "https://jeego.fr/",
    more: "https://www.notion.so/Jeego-Plateforme-Web-PWA-React-TypeScript-Node-2f87a480c77c80c585acd6ca96f10684?showMoveTo=true&saveParent=true",
  },
  {
    title: "Clone Vinted – Marketplace fullstack",
    type: "perso",
    date: "2023",
    description: "Interface moderne et responsive. Les utilisateurs peuvent créer un compte, publier des annonces, parcourir et filtrer les produits, et tester le paiement en ligne via Stripe (mode test). Projet fullstack React / Node.js, mettant en avant mes compétences en UI/UX et en gestion de données.",
    image: Img1,
    github: "https://github.com/PriscilH/Vinted-front",
    demo: "https://replique-vinted-priscil.netlify.app/",
    more: "https://www.notion.so/Vinted-Clone-Application-Marketplace-Fullstack-React-Node-js-MongoDB-2f97a480c77c805fbd1bc434da7be607?source=copy_link",
  },
  {
    title: "Marvel Explorer – Web App Fullstack",
    type: "perso",
    date: "2023",
    description: "Application web fullstack pour explorer les héros et comics Marvel. Frontend React.js réactif, backend Node.js/Express sécurisé avec MongoDB, intégration de l’API Marvel, recherche et pagination, authentification des utilisateurs, UI moderne et responsive.",
    image: Img3,
    github: "https://github.com/PriscilH/Marvel-Front",
    demo: "https://marvel-priscil.netlify.app/",
    more: "https://www.notion.so/Marvel-App-Application-Web-API-React-Node-js-MongoDB-2f97a480c77c80709f74c270490fc907?source=copy_link",
  },
  {
    title: "Airbnb Mobile",
    type: "perso",
    date: "2023",
    description: "Application mobile réalisée lors de ma formation, React Native / Expo pour parcourir et visualiser des logements. Ce projet m’a permis de travailler sur la navigation entre écrans, la gestion des composants réutilisables et l’intégration d’animations et assets multimédias.",
    image: Air,
    github: "https://github.com/PriscilH/Airbnb/blob/main/App.js",
    // demo: "#",
    more: "https://www.notion.so/Airbnb-Mobile-Clone-d-application-mobile-React-Native-Expo-Node-js-2f97a480c77c8050ab3feb4dd423b710?source=copy_link",
  },
  {
    title: "Watowatch – Application Web Séries",
    type: "perso",
    date: "2023",
    description: "Application web développée avec React permettant de parcourir et rechercher des séries via l’API TMDB. Affiche les détails essentiels (titre, synopsis, notes, affiches) avec une interface simple et responsive.",
    image: Wat,
    github: "https://github.com/PriscilH/TheMovieDB-React",
    demo: "https://the-movie-db-react-xi.vercel.app/",
    more: "https://www.notion.so/Watowatch-Application-Web-Films-React-TMDB-API-2f97a480c77c80639747d0e5e5856ada?source=copy_link",
  },
  {
    title: "Projets en cours de construction 🚧",
    type: "perso",
    date: "2025 - 2026",
    description: "Développement de nouveaux projets fullstack, incluant un dashboard interactif et une application IA (My-Mentor-AI). Le contenu sera mis à jour prochainement.",
    image: Pix,
  },
];

const Work = () => {
  const [category, setCategory] = useState("pro"); 
  const filteredProjects = projects.filter(
    (project) => project.type === category
  );

  return (
    <section className="section mt-16" id="work">
      <div className="container mx-auto  ">
        <h2 className="h2 text-accent mb-6">Mes Projets</h2>

        {/* // Toggle catégorie */}
        {/* <div className="flex gap-4 mb-12 relative z-50"></div> */}
        <div className="flex gap-4 mb-12 relative z-50">
          {["pro", "perso"].map((cat) => (
            <motion.button
              key={cat}
              onClick={() => setCategory(cat)}
              whileTap={{ scale: 0.9 }}
              whileHover={{ scale: 1.05 }}
              className={`
        px-4 py-2 rounded-xl font-semibold transition-all cursor-pointer
        ${
          category === cat
            ? "bg-accent text-white shadow-lg shadow-accent/50"
            : "bg-gray-700 text-gray-200 hover:bg-accent hover:text-white"
        }
      `}
            >
              {cat === "pro" ? "Pro" : "Perso"}
            </motion.button>
          ))}
        </div>

        {/* Grid des projets */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map((project, index) => (
            <Card3D key={index} project={project} />
          ))}
        </div>
      </div>
    </section>
  );
};

const Card3D = ({ project }) => {
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const rotateX = useTransform(y, [-100, 100], [15, -15]);
  const rotateY = useTransform(x, [-100, 100], [-15, 15]);

  const glowControls = useAnimation();

  useEffect(() => {
    glowControls.start({
      boxShadow: [
        "0 0 20px rgba(196,147,255,0.5),0 0 40px rgba(255,100,200,0.3),0 0 60px rgba(58,172,226,0.2)",
        "0 0 30px rgba(196,147,255,0.7),0 0 50px rgba(255,100,200,0.4),0 0 80px rgba(58,172,226,0.3)",
        // "0 0 20px rgba(196,147,255,0.5),0 0 40px rgba(255,100,200,0.3),0 0 60px rgba(58,172,226,0.2)",
      ],
      transition: { duration: 4, repeat: Infinity, ease: "easeInOut" },
    });
  }, [glowControls]);

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    x.set(e.clientX - rect.left - rect.width / 2);
    y.set(e.clientY - rect.top - rect.height / 2);
  };

  const handleMouseLeave = () => {
    x.set(0);
    y.set(0);
  };

  return (
    <motion.div
      className="relative cursor-pointer rounded-xl bg-black/20 backdrop-blur-xl overflow-hidden border-2 border-transparent"
      style={{ rotateX, rotateY }}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      animate={glowControls}
      whileHover={{ scale: 1.03 }}
      transition={{ duration: 0.3 }}
    >
      <motion.div
        className="absolute inset-0 rounded-xl pointer-events-none"
        style={{
          boxShadow:
            "0 0 20px rgba(196,147,255,0.5),0 0 40px rgba(255,100,200,0.3),0 0 60px rgba(58,172,226,0.2)",
        }}
      />
      <img
        src={project.image}
        alt={project.title}
        className="w-full h-48 object-cover rounded-t-xl"
      />
      <div className="p-4 flex flex-col gap-2 relative z-10">
        <h3 className="text-white font-semibold text-lg">{project.title} - {project.date}</h3>
        <p className="text-gray-200 text-sm">{project.description}</p>
        <div className="flex gap-4 mt-2">
          {project.github && (
            <a
              href={project.github}
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-blue-400 transition"
            >
              <FaGithub size={20} />
            </a>
          )}
          {project.demo && (
            <a
              href={project.demo}
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-pink-400 transition"
            >
              <FaExternalLinkAlt size={20} />
            </a>
          )}
          {project.more && (
            <a
              href={project.more}
              className="text-white hover:text-purple-400 transition"
            >
              <FaInfoCircle size={20} />
            </a>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default Work;